const PERSISTED_KEYS = ['cookiePreferences'];

export const clearLocalStorageExcept = (keysToKeep = PERSISTED_KEYS) => {
  try {
    const preservedEntries = keysToKeep
      .map((key) => [key, localStorage.getItem(key)])
      .filter(([, value]) => value !== null);

    localStorage.clear();

    preservedEntries.forEach(([key, value]) => {
      localStorage.setItem(key, value);
    });
  } catch (error) {
    // Fall back to a regular clear if read/write preservation fails.
    try {
      localStorage.clear();
    } catch (_) {}
  }
};
